export const customTheme = {
    token: {
        fontFamily: "Poppins",
    },
    components: {
        Table: {
            cellPaddingBlockSM: 14,
            cellFontSizeSM: 14,
            headerBg: "#ffffff",
            headerColor: "rgba(0,0,0,0.6)",
            headerBorderRadius: 6
        }
    }
};
